import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { completeMpBind } from '@/services/api'
import { useToastStore } from '@/stores/toast'

export default function BindComplete() {
  const location = useLocation()
  const [ticket, setTicket] = useState('')
  const [phone, setPhone] = useState('')
  const [displayName, setDisplayName] = useState('')
  const { show } = useToastStore()
  const [submitting, setSubmitting] = useState(false)
  const [success, setSuccess] = useState(false)
  const [appInfo, setAppInfo] = useState<{ appid: string; name?: string; channel?: string } | null>(null)
  const [redirectUrl, setRedirectUrl] = useState<string>('')

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const t = params.get('ticket') || ''
    setTicket(t)
    try {
      const parts = t.split('.')
      if (parts.length >= 2) {
        const payload = JSON.parse(decodeURIComponent(escape(window.atob(parts[1].replace(/-/g,'+').replace(/_/g,'/')))))
        const appid = String(payload.appid || '')
        const channel = String(payload.channel || '')
        const name = payload.name ? String(payload.name) : undefined
        const redirect = payload.redirect ? String(payload.redirect) : ''
        if (appid) setAppInfo({ appid, channel, name })
        if (redirect) setRedirectUrl(redirect)
      }
    } catch {}
  }, [location.search])

  useEffect(() => {
  }, [appInfo?.appid])

  const submit = async () => {
    if (!ticket || !phone) { show({ type: 'error', message: '请填写手机号' }); return }
    if (!/^\d{6,15}$/.test(phone)) { show({ type: 'error', message: '手机号格式不正确' }); return }
    try {
      setSubmitting(true)
      await completeMpBind({ ticket, phone, displayName: displayName || undefined })
      setSuccess(true)
      show({ type: 'success', message: '绑定成功' })
    } catch (e) {
      show({ type: 'error', message: '绑定失败，请重试或联系商户' })
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="bg-white shadow rounded-lg p-6 w-full max-w-md">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-2">
            <div className="h-8 w-8 rounded bg-wechat-green text-white flex items-center justify-center">√</div>
            <div className="text-lg font-semibold">完成授权绑定</div>
          </div>
          <button className="text-sm text-gray-600" onClick={()=>{ try { window.close() } catch {} if (redirectUrl) { window.location.href = redirectUrl } }}>关闭</button>
        </div>
        {appInfo && (
          <div className="mb-3 text-sm text-gray-700">
            <div>绑定应用：<b>{appInfo.name || appInfo.appid}</b></div>
            <div className="text-gray-500">AppID：{appInfo.appid}，渠道：{appInfo.channel || 'mp'}</div>
          </div>
        )}
        {!success && (
        <div className="flex items-center justify-between mb-4 text-sm">
          <div className="flex items-center gap-2">
            <span className="h-6 w-6 rounded-full bg-wechat-green text-white flex items-center justify-center">1</span>
            <span>微信内完成授权</span>
          </div>
          <div className="flex-1 h-px bg-gray-200 mx-3"></div>
          <div className="flex items-center gap-2">
            <span className="h-6 w-6 rounded-full bg-wechat-green text-white flex items-center justify-center">2</span>
            <span>填写手机号与用户名</span>
          </div>
          <div className="flex-1 h-px bg-gray-200 mx-3"></div>
          <div className="flex items-center gap-2">
            <span className="h-6 w-6 rounded-full bg-gray-300 text-white flex items-center justify-center">3</span>
            <span>完成绑定</span>
          </div>
        </div>
        )}
        
        {success ? (
          <div className="space-y-3">
            <div className="text-center text-green-600 font-semibold">绑定已完成</div>
            <div className="text-center text-sm text-gray-600">您可以关闭此页面</div>
            {redirectUrl && <a href={redirectUrl} className="block text-center text-wechat-green underline">返回商户主页</a>}
          </div>
        ) : (
        <div className="space-y-3">
          <div>
            <label className="block text-sm text-gray-700 mb-1">手机号</label>
            <input className="border rounded px-3 py-2 w-full focus:outline-none focus:ring-2 focus:ring-wechat-green" placeholder="请输入手机号" value={phone} inputMode="numeric" pattern="\d*" maxLength={15} minLength={6} onChange={e=>setPhone(e.target.value)} />
            <div className="mt-1 text-xs text-gray-500">仅用于匹配绑定记录，商户不会用于其他用途</div>
          </div>
          <div>
            <label className="block text-sm text-gray-700 mb-1">用户名（可选）</label>
            <input className="border rounded px-3 py-2 w-full focus:outline-none focus:ring-2 focus:ring-wechat-green" placeholder="请输入用户名" value={displayName} onChange={e=>setDisplayName(e.target.value)} />
            <div className="mt-1 text-xs text-gray-400">用于在商户系统内显示您的名称</div>
          </div>
          <button disabled={submitting} onClick={submit} className="bg-wechat-green text-white px-4 py-2 rounded w-full disabled:opacity-50 focus:outline-none focus:ring-2 focus:ring-wechat-green">
            {submitting ? '提交中...' : '确认绑定'}
          </button>
          <div className="text-xs text-gray-400 text-center">提交即表示同意仅用于完成绑定与转账到账用途</div>
        </div>
        )}
      </div>
    </div>
  )
}
